package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.component.image.Document
import com.wintermar.inspection.core.ui.component.image.util.FileGroupTypes
import com.wintermar.inspection.core.ui.component.image.util.FileUtil
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.widget.ImageGrid
import com.wintermar.inspection.feature.domain.model.answer.AnswerFileModel
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.files
import inspection.composeapp.generated.resources.ic_pencil
import inspection.composeapp.generated.resources.ic_trash
import org.jetbrains.compose.resources.stringResource

@Composable
fun ContentItemFile(
    files: List<AnswerFileModel> = emptyList(),
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onEditFiles: () -> Unit,
    onDeleteFiles: () -> Unit
) {
    val imageFiles by remember(files) {
        derivedStateOf {
            files.filter {
                FileGroupTypes.IMAGES.getExtensionsWithoutDot()
                    .contains(FileUtil.getExtensionFromFileName(it.name))
            }
        }
    }
    val documentFiles by remember(files) {
        derivedStateOf {
            files.filter {
                FileGroupTypes.DOCUMENTS.getExtensionsWithoutDot()
                    .contains(FileUtil.getExtensionFromFileName(it.name))
            }
        }
    }
    AnimatedVisibility(
        visible = files.isNotEmpty(),
        enter = fadeIn(),
        exit = fadeOut()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
                .background(
                    color = color.surface.neutral.subtlest.default,
                    shape = RoundedCornerShape(dimension.radius.md)
                )
                .padding(dimension.spacing.space3),
            verticalArrangement = Arrangement.spacedBy(dimension.spacing.space1)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement =
                    Arrangement.spacedBy(
                        dimension.spacing.space2,
                    ),
                verticalAlignment = Alignment.CenterVertically
            ) {
                TextBodySmall(
                    text = stringResource(Res.string.files),
                    bold = true,
                    modifier = Modifier.weight(1f)
                )

                if (files.none { it.isUploading() }) {
                    IconButton(
                        icon = Res.drawable.ic_pencil,
                        backgroundColor = Color.Transparent,
                        tint = color.icon.subtle,
                        onClick = {
                            onEditFiles()
                        }
                    )

                    IconButton(
                        icon = Res.drawable.ic_trash,
                        backgroundColor = Color.Transparent,
                        tint = color.icon.error.default,
                        onClick = {
                            onDeleteFiles()
                        }
                    )
                }
            }

            ImageGrid(
                files = imageFiles.map { file ->
                    file.toFileModel()
                },
                modifier = Modifier.fillMaxWidth()
            )

            documentFiles.forEach {
                Document(
                    file = it.toFileModel()
                )
            }
        }
    }
}
